import type { Locale } from '@/helpers/languages';
import { AVAILABLE_LOCALES } from '../constants';

export const detectBrowserLanguage = (acceptLanguage: string) =>
  acceptLanguage
    .split(',')
    .map((lang) => {
      const [code, qValue] = lang.split(';q=');
      return { code: code.trim(), weight: Number.parseFloat(qValue) || 1.0 };
    })
    .sort((a, b) => b.weight - a.weight)
    .find(({ code }) => [...AVAILABLE_LOCALES, 'fr'].includes(code as Locale));
